import { render, staticRenderFns } from "./CreateForwarder.vue?vue&type=template&id=0afb16cf&"
import script from "./CreateForwarder.vue?vue&type=script&lang=js&"
export * from "./CreateForwarder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0afb16cf')) {
      api.createRecord('0afb16cf', component.options)
    } else {
      api.reload('0afb16cf', component.options)
    }
    module.hot.accept("./CreateForwarder.vue?vue&type=template&id=0afb16cf&", function () {
      api.rerender('0afb16cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Forwarders/CreateForwarder.vue"
export default component.exports